import React, { useEffect, useRef, useState } from "react";
import { Result } from "antd";
import Loader from "Common/Loader";
import { Card } from "react-bootstrap";
import { BiSolidRightArrowAlt } from "react-icons/bi";

import DataGrid, {
  Column,
  Pager,
  Paging,
  SearchPanel,
  Selection,
  Summary,
  TotalItem,
  DataGrid as DataGridType,
  Scrolling,
} from "devextreme-react/cjs/data-grid";
import CustomStore from "devextreme/data/custom_store";
import {
  GeneratePurchaseOrderItemBagApi,
  GetAllPurchaseOrderBaggingList,
} from "../service";
import { HttpStatus } from "modules/core";
import notistack from "modules/core/notistack";
import { BaggingList } from "../model/baggin-list";
import moment from "moment";

const BaggingDataList: React.FC = () => {
  const gridRef = useRef<DataGridType | null>(null);

  const [loading, setLoading] = useState(false);
  const [permissionDetails, setPermissionDetails] = useState<string[]>([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  useEffect(() => {
    const authUserString = localStorage.getItem("authPOSUser");
    if (authUserString) {
      const authUser = JSON.parse(authUserString);
      const permissionData = authUser?.permissions || [];
      setPermissionDetails(permissionData);
    }
  }, []);

  const HasPermission = (permission: string): boolean => {
    return permissionDetails.includes(permission);
  };

  const updateDiamondAndGoldInword = async () => {
    try {
      if (selectedRows.length === 0) {
        notistack.warning("Please select product");
        return;
      }

      setLoading(true);

      const model = new BaggingList();
      model.purchaseOrderItemBaggingIds = selectedRows.map(
        (el) => el.purchaseOrderItemId
      );

      const response: any = await GeneratePurchaseOrderItemBagApi(model);

      if (response?.status === HttpStatus?.Success) {
        notistack.success("Purchase order received successfully.");
        gridRef.current?.instance?.refresh();
        setSelectedRows([]);
      } else {
        const message =
          response?.message || "Something went wrong. Please try again.";
        notistack.error(message);
      }
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Unexpected error occurred while generating the bagging list.";
      notistack.error(errorMsg);
      console.error("Failed to generate bagging list:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleSelectionChange = (e: any) => {
    setSelectedRows(e.selectedRowsData);
  };

  const dataSource = () => {
    return new CustomStore({
      key: "purchaseOrderItemId",
      load: async (loadOptions) => {
        try {
          const { searchValue, skip, take } = loadOptions;
          console.log(searchValue)
          const parameterList = new URLSearchParams();
          if (typeof skip === 'number') parameterList.append('skip', skip.toString());
          if (typeof take === 'number') parameterList.append('take', take.toString());
          const search = JSON.parse(JSON.stringify(loadOptions));
          for (const [key, value] of Object.entries(search)) {
            parameterList.append(key, JSON.stringify(value));
          }
          if (searchValue) {
            parameterList.append("search", searchValue);
          }
          const response: any = await GetAllPurchaseOrderBaggingList(parameterList);
          // return {
          //   data: response?.data || [],
          //   totalCount: response?.totalCount || response?.data?.length,
          // };
          return response;
        } catch (error) {
          console.error("Data loading error:", error);
          return { data: [], totalCount: 0 };
        }
      },
    });
  };

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content">
        <div className="container-fluid">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="m-0">Generate Old Gold  Purchase Bag</h5>
              <button
                className="submit-btn"
                title="Generate bag"
                onClick={updateDiamondAndGoldInword}
              >
                <BiSolidRightArrowAlt size={25} />
              </button>
            </Card.Header>
            <Card.Body className="pt-0">
              {/* {HasPermission("MetalColor.Read") ? ( */}
              <DataGrid
                dataSource={dataSource()}
                remoteOperations={{ filtering: true, paging: true, sorting: true }}
                showRowLines
                showBorders
                keyExpr="purchaseOrderItemBaggingIds"
                columnAutoWidth={true}
                ref={gridRef}
                onSelectionChanged={handleSelectionChange}
                onContentReady={(e) => {
                  const hasData = e.component.totalCount() > 0;
                  e.component.option("pager.visible", hasData);
                  e.component.option("paging.visible", hasData);
                }}
              >
                <Scrolling
                  mode='standard'
                  useNative={true}
                  scrollByContent={true}
                  scrollByThumb={true}
                />
                <Selection mode="multiple" />
                <Pager
                  showPageSizeSelector
                  allowedPageSizes={[10, 25, 50, 100]}
                  showNavigationButtons
                  displayMode="full"
                  showInfo
                />
                <Summary>
                  <TotalItem
                  // column="Sr.No."
                  // summaryType="count"
                  // displayFormat="Total Items: {0}"
                  />
                </Summary>
                <Paging defaultPageSize={10} />
                <SearchPanel visible width={240} placeholder="Search..." />

                <Column
                  caption="Sr.No."
                  dataType="number"
                  alignment="center"
                  cellRender={(e) => {
                    const rowIndex =
                      e.rowIndex +
                      1 +
                      e.component.pageIndex() * e.component.pageSize();
                    return <span>{rowIndex}</span>;
                  }}
                />
                <Column cssClass="text-center" dataField="poNumber" width={200} caption="PO Number" />
                <Column
                  cssClass="text-center" dataField="purchaseOrderDate"
                  caption="PO Date"
                  dataType="date"
                  cellRender={({ data }) => moment(data.purchaseOrderDate).format('DD/MM/YYYY')}
                />
                <Column cssClass="text-center" dataField="karat" caption="Metal Kt" />
                <Column
                  cssClass="text-center" dataField="rate"
                  caption="Rate"
                  dataType="number"
                  format="#,##0.00"
                />
                <Column
                  cssClass="text-center" dataField="purity"
                  caption="Purity"
                  dataType="number"
                  format="#,##0.00"
                />
                <Column
                  cssClass="text-center" dataField="netWeight"
                  caption="Net Weight"
                  dataType="number"
                  format="#,##0.000"
                />
                <Column
                  cssClass="text-center" dataField="equivalentWeight"
                  caption="Equivalent Weight"
                  dataType="number"
                  format="#,##0.000"
                />
                <Column
                  cssClass="text-center" dataField="purchaseAmount"
                  caption="Purchase Amount"
                  dataType="number"
                  format="₹ #,##0.00"
                />
                <Column cssClass="text-center" dataField="note" caption="Note" />
              </DataGrid>
              {/* ) : ( */}
              {/* )} */}
            </Card.Body>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BaggingDataList;
